import { Component, Element, h, Host, Prop, State } from "@stencil/core";
import pfx from "../../../utils/style-class-prefix-helper";
import { getFirstNestedChild } from "../../../utils/dom-helper";
import { Components } from "../../../components";
import {
  MULTI_CONTENT_STAGE_DEFAULT_PROMO_FLAG_ALIGNMENT,
  MultiContentStagePromoFlagAlignment
} from "../../../constants/global-constants";
import EonUiPromoFlag = Components.EonUiPromoFlag;
import { StyledComponent } from "../../../decorators/styled-component";

// import { InitLogging } from "../../../decorators/init-logging";

/**
 * @slot [unnamed] - holds any number of HTML elements.
 * @slot [stage-item-image] - holds one eon-ui-image component as item image.
 * @slot [stage-item-background] - holds one eon-ui-image component as background.
 */
@Component({
  tag: "eon-ui-multi-content-stage-item",
  styleUrl: "multi-content-stage-item.scss",
  shadow: true
})
export class MultiContentStageItem {
  // @InitLogging() sentryTransaction;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiMultiContentStageItemElement;

  /**
   * Determines whether the stage is active or not
   */
  @Prop() isActive: boolean;

  /**
   * Is promo-flag available or not
   */
  @Prop({ reflect: true, mutable: true }) hasPromoFlag: boolean;

  /**
   * Alignment of promoflag if exists
   */
  @State() promoFlagAlignment: MultiContentStagePromoFlagAlignment = MULTI_CONTENT_STAGE_DEFAULT_PROMO_FLAG_ALIGNMENT;

  /**
   * PromoFlag small or normal if exists
   */
  @Prop({ reflect: true, mutable: true }) promoFlagSmall: boolean;

  componentWillLoad() {
    const promoFlag = getFirstNestedChild(this.hostElement, "eon-ui-promo-flag") as EonUiPromoFlag;
    this.hasPromoFlag = !!promoFlag;
    this.promoFlagAlignment = promoFlag?.alignment as MultiContentStagePromoFlagAlignment;
    this.promoFlagSmall = promoFlag?.small;
  }

  render() {
    return (
      <Host>
        <div
          class={pfx({
            "mcs-content": true,
            active: this.isActive,
            "has-promo-flag": this.hasPromoFlag,
            "promo-flag-small": this.promoFlagSmall
          })}
        >
          <slot />
          <slot name="stage-item-image" />
          <slot name="stage-item-background" />
          {this.hasPromoFlag && (
            <div
              class={pfx({
                "mcs-promo-flag": true,
                [this.promoFlagAlignment]: true
              })}
            >
              <slot name="promo-flag" />
            </div>
          )}
        </div>
      </Host>
    );
  }
}
